<style lang="scss" scoped>
@import '$vars';

.appointment-time {
  @apply mx-2 inline-flex self-stretch items-center justify-center;
  @apply relative;
  height: 2rem;

  &__icon {
    @apply block w-4 cursor-pointer;
  }

  &__form {
    @apply absolute shadow p-2 z-50;
    background: white;
    left: 0;
    top: 100%;
    width: 10rem;
  }

  &__field {
    @apply w-full mr-0 pr-0;
    background: rgb(242, 242, 242);
    border-radius: 4px;

    &:hover {
      background: rgb(242, 242, 242) !important;
    }
  }

  &__input {
    @apply w-full px-2 py-2;
    background: rgb(242, 242, 242);
    border-radius: 4px;
    color: rgb(74, 74, 74);
    font-size: 0.7rem;

    &.has-error {
      background: rgb(255, 245, 245);
      box-shadow: 0 0 2px 1px rgba(249, 108, 113, 0.5) !important;
    }
  }
}

.report__filters-item {
  @apply mr-0;
}

.dr-timepicker:hover {
  background: rgb(242, 242, 242) !important;
}
</style>

<template>
  <div
    v-click-outside="() => (ui.isOpen = false)"
    class="appointment-time"
  >
    <div @click="ui.isOpen = !ui.isOpen">
      <dr-icon
        class="appointment-time__icon"
        name="edit"
        color="#56bdd2"
      />
    </div>

    <div
      v-if="ui.isOpen"
      class="appointment-time__form"
    >
      <!-- Start date -->
      <div class="report__filters-item">
        <label class="report__filters-label">
          Data inicial
        </label>

        <div class="report__filters-field appointment-time__field">
          <dr-datepicker
            v-model="local.startDate"
            type="calendar"
            @change="validatePeriods"
          />
        </div>
      </div>

      <!-- Final date -->
      <div class="report__filters-item">
        <label class="report__filters-label">
          Data final
        </label>

        <div class="report__filters-field appointment-time__field">
          <dr-datepicker
            v-model="local.endDate"
            type="calendar"
            @change="validatePeriods"
          />
        </div>
      </div>

      <div class="flex flex-row justify-between">
        <!-- Starting Time -->
        <div class="report__filters-item" style="width: 48%">
          <label class="report__filters-label">
            Horário inicial
          </label>

          <div class="report__filters-field appointment-time__field">
            <input
              v-model="local.startTime"
              v-mask="['##:##']"
              :class="{ 'has-error': !validateTime(local.startTime) }"
              class="appointment-time__input"
              type="text"
            />
          </div>
        </div>

        <!-- Starting Time -->
        <div class="report__filters-item" style="width: 48%">
          <label class="report__filters-label">
            Horário inicial
          </label>

          <div class="report__filters-field appointment-time__field">
            <input
              v-model="local.endTime"
              v-mask="['##:##']"
              :class="{ 'has-error': !validateTime(local.endTime) }"
              class="appointment-time__input"
              type="text"
            />
          </div>
        </div>
      </div>

      <div class="flex flex-row justify-end mt-3">
        <button
          type="submit"
          :disabled="isDisabled || ui.isLoading"
          class="btn btn-sm btn-blue"
          @click="saveInterval"
        >
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DrDatepicker from '@/components/form/datepicker'

export default {
  name: 'EditAppointmentTime',

  components: {
    DrDatepicker
  },

  props: {
    appointmentId: {
      type: Number,
      required: true
    },

    startDateTime: {
      type: String,
      required: true
    },

    endDateTime: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      ui: {
        isOpen: false,
        isLoading: false
      },
      local: {
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null
      }
    }
  },

  computed: {
    isDisabled () {
      const startTime = this.$moment(this.local.startDate)
        .set({
          hour: this.local.startTime.split(':')[0],
          minute: this.local.startTime.split(':')[1],
          second: 0,
          millisecond: 0
        })

      const endTime = this.$moment(this.local.endDate)
        .set({
          hour: this.local.endTime.split(':')[0],
          minute: this.local.endTime.split(':')[1],
          second: 0,
          millisecond: 0
        })

      return startTime.isAfter(endTime, 'second')
    }
  },

  created () {
    this.local.startDate = this.$moment(this.startDateTime).toISOString()
    this.local.endDate = this.$moment(this.endDateTime).toISOString()
    this.local.startTime = this.$moment(this.startDateTime).format('HHmm')
    this.local.endTime = this.$moment(this.endDateTime).format('HHmm')
  },

  methods: {
    validatePeriods () {
      const startDate = this.$moment(this.local.startDate)
      const endDate = this.$moment(this.local.endDate)

      if (startDate.isAfter(endDate, 'days')) {
        this.local.startDate = this.local.endDate
      }

      if (endDate.isBefore(endDate, 'days')) {
        this.local.endDate = this.local.startDate
      }
    },

    validateTime (time = '') {
      const validTime = new RegExp(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'gi')

      return validTime.test(time)
    },

    saveInterval () {
      const start = this.$moment(this.local.startDate)
        .set({
          hour: this.local.startTime.split(':')[0],
          minute: this.local.startTime.split(':')[1],
          second: 0,
          millisecond: 0
        })
        .format('YYYY-MM-DD HH:mm')

      const finish = this.$moment(this.local.endDate)
        .set({
          hour: this.local.endTime.split(':')[0],
          minute: this.local.endTime.split(':')[1],
          second: 0,
          millisecond: 0
        })
        .format('YYYY-MM-DD HH:mm')

      const url = `/agenda/${this.appointmentId}/medical_consultation_interval`

      const data = {
        'medical_consultation_interval': {
          medicalConsultationStart: start,
          medicalConsultationFinish: finish
        }
      }

      this.fn_SHOW_PROGRESS()

      this.$http
        .put(url, data, this.$store.getters.getAuthHeader)
        .then(() => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'O horário da consulta foi editado com sucesso.',
            size: 'md',
            active: true
          })

          this.ui.isOpen = false
          this.$emit('new-interval', this.getNewInterval(start, finish))
        })
        .catch(this.fn_HANDLE_ERROR)
        .finally(this.fn_HIDE_PROGRESS)
    },

    getNewInterval (start, finish) {
      const min = this.$moment(finish).diff(start, 'minutes')
      const now = this.$moment().startOf('day').set({ minute: min })

      return now.format('HH[h]mm[min]')
    }
  }
}
</script>
